export default __webpack_public_path__ + "static/media/codin.5b864cd7.svg";